<template>
  <v-card class="app-card" style="margin-bottom:0px;">
    <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
      <v-card-title class="app-card-title"
        >Editar Endereço/Contato</v-card-title
      >
      <v-card-text class="app-card-content">
        <fieldset>
          <legend>Endereço</legend>
          <v-row>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
              <v-text-field
                v-model="form.logradouro"
                placeholder="Ex.: Rua das Acácias"
                label="Endereço *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
              <v-text-field
                v-model="form.numeroLogradouro"
                placeholder="Ex.: 3456"
                v-mask="'#########'"
                label="Número *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
              <v-text-field
                v-model="form.bairro"
                placeholder="Ex.: Antonio Bezerra"
                label="Bairro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>
        <fieldset>
          <legend>Contato</legend>
          <v-row>
            <v-col :md="2" :sm="2" :xs="12" cols="12" class="pt-0">
              <div class="form-control mb-5">
                <label for="ddd">DDD *</label>
                <InputMask
                  id="ddd"
                  v-model="form.dddTelefone"
                  placeholder="Ex.: 85"
                  maskT="##"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
              <div class="form-control mb-5">
                <label for="telefone">Telefone *</label>
                <InputMask
                  id="telefone"
                  v-model="form.telefone"
                  placeholder="Ex.: 98755-9988"
                  maskT="#####-####"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col :md="2" :sm="2" :xs="12" cols="12" class="pt-0">
              <div class="form-control mb-5">
                <label for="ddd2">DDD 2</label>
                <InputMask
                  id="ddd2"
                  v-model="form.telefones[0].ddd"
                  placeholder="Ex.: 85"
                  maskT="##"
                />
              </div>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
              <div class="form-control mb-5">
                <label for="telefone2">Telefone 2</label>
                <InputMask
                  id="telefone2"
                  v-model="form.telefones[0].telefone"
                  placeholder="Ex.: 98755-9988"
                  maskT="#####-####"
                  :masked="true"
                />
              </div>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0">
              <v-text-field
                type="email"
                v-model="form.email"
                placeholder="Ex.: seuemail@exemplo.com"
                label="Email "
                :rules="[rules.email]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="10" :sm="10" :xs="12" cols="12" class="pt-0 pb-0">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
                class="recaptcha"
              ></vue-recaptcha>
              <v-input
                v-model="form.recaptcha"
                :rules="[rules.required]"
                style="margin-top: -23px;"
              ></v-input>
            </v-col>
          </v-row>
        </fieldset>
        <div class="loading" v-if="isLoading">
          <v-progress-circular
            :size="25"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          depressed
          outlined
          color="error"
          @click="closeDialogEditForm(false)"
          >Fechar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" type="submit">Salvar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mask } from "vue-the-mask";
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import moment from "moment";

import BeneficiarioService from "@/services/beneficiario.service";

import BeneficiarioAuthService from "@/services/beneficiarioCearaApp.auth.service";

import InputMask from "@/components/form/InputMask";
import { maskT } from "@/directives/mask";

export default {
  name: "EditForm",
  components: {
    VueRecaptcha,
    InputMask
  },
  directives: {
    mask,
    maskT
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      beneficiario: null,
      form: {
        logradouro: null,
        numeroLogradouro: null,
        bairro: null,
        dddTelefone: null,
        telefone: null,
        email: null,
        recaptcha: null,
        telefones: [
          {
            id: null,
            ddd: "",
            telefone: ""
          }
        ]
      },
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        cpf: value => !!validateCpf(value) || "CPF inválido",
        email: v => (v ? /.+@.+\..+/.test(v) || "E-mail inválido" : true)
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const {
          logradouro,
          numeroLogradouro,
          bairro,
          dddTelefone,
          telefone,
          email,
          recaptcha,
          telefones
        } = this.form;
        BeneficiarioService.updateAddress(
          this.beneficiario.id,
          this.beneficiario.cep,
          logradouro,
          numeroLogradouro,
          bairro,
          dddTelefone,
          telefone,
          email,
          recaptcha,
          telefones
        ).subscribe(
          res => {
            BeneficiarioAuthService.changeSession(res);
            this.isLoading = false;
            this.expiredRecaptcha();
            this.closeDialogEditForm(false);
            location.reload();
          },
          error => {
            this.expiredRecaptcha();
            this.isLoading = false;
          }
        );
      }
    },
    setForm() {
      this.form.logradouro = this.beneficiario.logradouro;
      this.form.numeroLogradouro = this.beneficiario.numeroLogradouro;
      this.form.bairro = this.beneficiario.bairro;
      this.form.dddTelefone = this.beneficiario.dddTelefone;
      this.form.telefone = this.beneficiario.telefone;
      this.form.email = this.beneficiario.email;

      if (this.beneficiario.telefones && this.beneficiario.telefones.length) {
        this.form.telefones = this.beneficiario.telefones;
      }
    },
    iniData() {
      const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();
      BeneficiarioService.findByCpfNascimento(
        beneficiario.cpf,
        beneficiario.dataNascimento
      ).subscribe(res => {
        this.beneficiario = res;
        this.setForm();
      });
    },
    closeDialogEditForm(state) {
      this.$emit("closeDialogEditForm", state);
    }
  },
  mounted() {
    this.iniData();
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  border: none;
  padding: 10px 0px;
  legend {
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>
